import { Component, OnInit } from '@angular/core';
import { DefaultEditor } from 'ng2-smart-table';
import { Empaque, Tarima } from '../../interfaces/beans.interface';
import { EmpaqueService } from '../../services/empaque.service';
import { ToastrService } from 'ngx-toastr';
import { TarimaService } from '../../services/tarima.service';
import { Router } from '@angular/router';

@Component({
  templateUrl: './select-editor.component.html'
})
export class SelectEditorComponent extends DefaultEditor implements OnInit {
  // Variables para mensajes de alertas
  messageAlert: string;
  typeAlert: string;
  // Variables que se pueden cargar al select
  mostrarEmpaque: boolean = false;
  empaques: Empaque[] = [];
  mostrarTarima: boolean = false;
  tarimas: Tarima[] = [];

  constructor(private empaqueService: EmpaqueService, private tarimaService: TarimaService, private toastr: ToastrService, private router: Router) {
    super();
  }

  ngOnInit() {
    if (this.cell.getColumn().id === 'tarima') {
      this.mostrarTarima = true;
      this.tarimaService.getFull().subscribe(
        messageTarima => {
          if (messageTarima['httpStatus'] === 200) {
            this.tarimas = messageTarima['tarimas'];
          }
        },
        error => {
          if (error.status === 0) {
            this.showMessage('error', 'Error de conexión', 'No existe conexión para obtener las tarimas');
            this.showMessageAlert('danger', 'No existe conexión para obtener las tarimas');
          } else if (error.status === 403) {
            this.goLogin();
          }
        }
      );
    } else if (this.cell.getColumn().id === 'empaque') {
      this.mostrarEmpaque = true;
      this.empaqueService.getFull().subscribe(
        messageEmpaque => {
          if (messageEmpaque['httpStatus'] === 200) {
            this.empaques = messageEmpaque['empaques'];
          }
        },
        error => {
          if (error.status === 0) {
            this.showMessage('error', 'Error de conexión', 'No existe conexión para obtener los empaques');
            this.showMessageAlert('danger', 'No existe conexión para obtener los empaques');
          } else if (error.status === 403) {
            this.goLogin();
          }
        }
      );
    }
  }

  equalTarima(t1: Tarima, t2: Tarima) {
    return t1.id === t2.id;
  }

  equalEmpaque(e1: Empaque, e2: Empaque) {
    return e1.id === e2.id;
  }

  showMessage(tipo: string, titulo: string, descripcion: string) {
    switch (tipo) {
      case 'success':
        this.toastr.success(descripcion, titulo);
        break;
      case 'error':
        this.toastr.error(descripcion, titulo);
        break;
      case 'warning':
        this.toastr.warning(descripcion, titulo);
        break;
      case 'info':
        this.toastr.info(descripcion, titulo);
        break;
    }
  }

  showMessageAlert(tipo: string, mensaje: string) {
    this.messageAlert = mensaje;
    this.typeAlert = tipo;
    setTimeout(() => this.messageAlert = null, 5000);
  }

  goLogin() {
    localStorage.clear();
    this.router.navigate(['']);
  }
}
